"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconCheck = function IconCheck(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16",
    height: "16",
    className: (0, _classnames.default)('Icon', 'IconCheck', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("g", {
    id: "check",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }, _react.default.createElement("g", {
    id: "check",
    transform: "translate(0.000000, 2.000000)"
  }, _react.default.createElement("path", {
    d: "M14.4123016,1.20358731 C14.2286056,1.01837882 13.9785509,0.914201676 13.7176938,0.914201676 C13.4568368,0.914201676 13.2067821,1.01837882 13.0230861,1.20358731 L5.7345966,8.50186003 L2.67245269,5.42993291 C2.41555524,5.18177346 2.04578072,5.08951784 1.70241962,5.18791783 C1.35905851,5.28631783 1.09427554,5.56042415 1.00781189,5.90698358 C0.921348232,6.25354302 1.02633978,6.61990496 1.28323724,6.8680644 L5.03998888,10.624816 C5.22368484,10.8100245 5.47373957,10.9142017 5.7345966,10.9142017 C5.99545364,10.9142017 6.24550837,10.8100245 6.42920433,10.624816 L14.4123016,2.6417188 C14.6130639,2.45650744 14.7272552,2.19579912 14.7272552,1.92265306 C14.7272552,1.64950699 14.6130639,1.38879867 14.4123016,1.20358731 Z",
    id: "Path"
  })))));
};

var _default = IconCheck;
exports.default = _default;